(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	function btyHeaderSticky( doc = document ) {
		const header = doc.querySelector( '.header.transparent-header' );
		if ( ! header ) return;
		if ( header.dsStickyCleanup ) header.dsStickyCleanup();

		const hasTopbar = document.querySelector( '.topbar-section ~ .header-section' );
		const detectScroll = function() {
			header.classList.toggle( 'is-sticky', window.scrollY > 50 );
		};

		if ( ( window.Shopify && Shopify.designMode ) || ! hasTopbar || ! ( 'IntersectionObserver' in window ) ) {
			detectScroll();
			window.addEventListener( 'scroll', detectScroll, { passive: true } );
			header.dsStickyCleanup = function() {
				window.removeEventListener( 'scroll', detectScroll );
			};
		} else {
			const observer = new IntersectionObserver(
				([entry]) => header.classList.toggle( 'is-sticky', entry.intersectionRatio < 1 ),
				{ rootMargin: '-1px 0px 0px 0px', threshold: [1] }
			);
			observer.observe( header );
			header.dsStickyCleanup = function() { observer.disconnect(); };
		}
	}

	btyHeaderSticky();

	document.addEventListener(
		'shopify:section:select',
		function( e ) {
			let section = e.target;
			btyHeaderSticky( section );
		}
	);

	document.addEventListener(
		'shopify:block:select',
		function( e ) {
			let section = document.getElementById( 'shopify-section-' + e.detail.sectionId );
			btyHeaderSticky( section );
		}
	);

  } catch(e) { console.error(e); }
})();
})();
